<div class="panel" [class.panel_expanded]="isExpanded$ | async">

  <div class="panel__title" (click)="toggleExpand()">
    <b>{{ title | translate }}</b>
  </div>

  <div class="panel__list">
    <div class="option" *ngFor="let option of options; trackBy: trackByFn">

      <div class="option__icon">
        <div *ngIf="option.bullet === bullets.dot" class="dot"></div>
      </div>

      <span class="option__label">{{ option.label | translate }}</span>

    </div>
  </div>
</div>
